import { useReduxState } from 'hooks';
import { ConfirmButton, ConfirmDeleteButton } from 'components/common';

interface Props {
  commentId: number;
  onDelete: (
    commentId: number,
    parentCommentId?: number,
    deletionReason?: string
  ) => Promise<void>;
  parentCommentId?: number;
}

const ReaderBlockDsicussionCommentDelete = ({
  commentId,
  onDelete,
  parentCommentId
}: Props) => {
  const {
    messages,
    pageState: { readOnly, courseSlug },
    serverConfig: { requireReasonWhenDeletingData }
  } = useReduxState();

  const deleteComment = async (values?: { deletionReason?: string }) => {
    await onDelete(commentId, parentCommentId, values?.deletionReason);
    return true;
  };

  return requireReasonWhenDeletingData ? (
    <ConfirmDeleteButton
      buttonIsDropdown={true}
      buttonText={messages.commonDelete}
      confirmText={messages.readerDiscussionDeleteCommentConfirm}
      confirmTitle={messages.readerDiscussionDeleteComment}
      id={`deletionReasonDiscussionComment-${commentId}`}
      onConfirm={deleteComment}
      successMessage={messages.readerDiscussionDeleteCommentSuccess}
    />
  ) : (
    <ConfirmButton
      actionText={messages.commonDelete}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={messages.commonDelete}
      category="danger"
      confirmText={messages.readerDiscussionDeleteCommentConfirm}
      confirmTitle={messages.readerDiscussionDeleteComment}
      disabled={readOnly}
      onConfirm={deleteComment}
      successMessage={messages.readerDiscussionDeleteCommentSuccess}
    />
  );
};

export default ReaderBlockDsicussionCommentDelete;
